let configData = {
    /**
     * 接口公用的一段
     */
    ajaxHost: "/api/serv",
    /**
     * 接口正常的时候返回的 status
     */
    apiStatus: 0,
    /**
     * 打开项目时不是根目录下的一段  比如  http://10.0.110.31/oms/#/login ,就要 写上 oms
     */
    host: "",
    /**
     * 图片路径要加上这一段才能显示出来
     */
    fileImg: "/api/file/",
    /**
     * 默认备案信息
     */
    footText: "珠海興諾能源科技有限公司粵ICP備19041187號 © Copyright",
    /**
     * 备案跳转地睛
     */
    footerUrl: "https://beian.miit.gov.cn",
    /**
     * 默认备案信息 英文
     */
    footTextEnglish: "Zhuhai Xingnuo Energy Technology Co., Ltd. Guangdong ICP No. 19041187 © Copyright",
    /**
     * 独立部署有的有可能有自定义的登录页面
     */
    loginUrl: "",
    /**
     * 全局按钮表单的大小 small
     */
    formSize: "small",
    /**
     * 在id = app 的根元素的 class  全局变灰：theme-gray
     */
    appThemeClass: "",
    /**
     * 日期选择：今天以后都不能选
     */
    pickerOptions: {
        disabledDate(time) {
            return time.getTime() > new Date().setHours(0, 0, 0, 0);
        },
    },
    /**
     * 日期选择：今天以后都不能选（包含今天）
     */
    pickerOptionsTomorrow: {
        disabledDate(time) {
            return time.getTime() > new Date().setHours(0, 0, 0, 0) - 1;
        },
    },
    /**
     * 日期选择：往前一个月开始到后面都不能选
     */
    pickerOptionsPreMonth: {
        disabledDate(time) {
            return (time.getTime() >
                new Date().setHours(0, 0, 0, 0) - 60 * 60 * 24 * 30 * 1000);
        },
    },
    /**
     * 日期选择：今天以前都不能选
     */
    pickerOptionsMin: {
        disabledDate(time) {
            return time.getTime() < new Date().setHours(0, 0, 0, 0);
        },
    },
    /**
     * 日期选择：今天以前都不能选,包括今天
     */
    pickerOptionsMin2: {
        disabledDate(time) {
            return time.getTime() < new Date().setHours(0, 0, 0, 0) + 1;
        },
    },
    /**
     * 弹出框是否可以拖动， 有一些用，有一些没有用，暂时不能删除，如果要启用，要在 Modal 组件上全部加上
     */
    draggable: false,
    /**
     * 兴诺企业的地图
     */
    mapKeyApi: "38963cf6e1d7092a3dfcf940b4979bd5",
    /**
     * 权限别名
     */
    powerObj: {
        // 权限对应的code,在页面里面直接用 xx.query 来做按钮权限,权限直接加入到 $route.meat 里面的 privilegeVoList
        "100501": "query",
        "100502": "add",
        "100503": "updata",
        "100504": "delete",
        "100505": "logout",
        "100506": "audit",
        "100507": "handle",
        "100508": "export",
        "100509": "endOrder",
        "100510": "grant",
        "100511": "stop",
        "100512": "relevance",
        "100513": "cancelRelevance",
        "100514": "recharge",
        "100515": "refund",
        "100516": "blacklist",
        "100517": "openCar",
        "100518": "import",
        "100519": "give",
        "100520": "invalid",
        "100521": "site",
        "100522": "line",
        "100523": "entMember",
        "100524": "userGroup",
        "100525": "bind",
        "100526": "set",
        "100527": "adjust",
        "100528": "homeData",
        "100529": "orderlyCharging",
    },
    /**
     * 在 add-router 的方法里保存了：所有的权限主路由，按{路由: name} 格式
     */
    autoUrl: {},
    /**
     * iview table 的  stripe参数, 有一些用，有一些没有用，暂时不能删除，
     */
    tableStripe: false,
    // 打开地图默认位置
    position: {
        lat: 22.546054,
        lng: 114.025974,
        city: "",
    },
    /**
     * 订单详情是否显示图表,如果不写默认不显示
     */
    orderDetailsEcharts: true,
    /**
     * 非实名卡发卡器用的
     */
    socketServer: "ws://127.0.0.1:8784/Pilot",
    downloadUrl: "http://files.qn.smartpevc.com/%E6%B4%BE%E8%AF%BA%E5%8F%91%E5%8D%A1%E6%8F%92%E4%BB%B620191209.exe",
    downloadUrl32: "http://files.qn.smartpevc.com/USB%E8%BD%ACRS232_WIN.zip",
    downloadUrlXP32: "http://files.qn.smartpevc.com/USB%E8%BD%ACRS232_XP.zip",
    downLoadNet35: "http://download.microsoft.com/download/2/0/E/20E90413-712F-438C-988E-FDAA79A8AC3D/dotnetfx35.exe",
    /**
     * 在线卡最大金额
     */
    onLineMax: null,
    /**
     * 离线卡最大金额
     */
    offLineMax: null,
    /**
     * 富文本编辑器的路径
     */
    UEDITOR_HOME_URL: "/ueditor/",
    /**
     * 模态框最大尺寸
     */
    modalWidthLarge: 1120,
    /**
     * 模态的中等尺寸
     */
    modalWidth: 720,
    /**
     * 模态的小尺寸
     */
    modalWidthSmall: 540,
    /**
     * 表格名称的配置
     */
    tableName: {
        minWidth: 184,
        tooltip: true,
    },
    /**
     * 表格价格的配置
     */
    tablePrice: {
        align: "right",
    },
    /**
     * 系统管理的菜单Id
     */
    sysModulePkId: "3",
    /**
     * 是否有多语言
     */
    languageShow: true,
};
//为了防止哪天在域名中间加了东西 或者接口域名变了 ，然后外面连接一个js 文件 js 文件里放这几个参数就可以了
// 其它打包路径已设置为相对路径 ,只和 static  和 index.html 文件 在同一层级就可以了
const win = window;
if (win.appConfig && typeof win.appConfig == "object") {
    configData = Object.assign(configData, win.appConfig);
}
export default configData;
